import API from "./index"

export const getLegends = () => API.get(`/legends`)
export const createLegend = (data) => API.post(`/legends`, data)
export const deleteLegend = (id) => API.delete(`/legends/${id}`)